import type { DocNode } from '@atlaskit/adf-schema';
import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import type { DocumentUpdateCommandProcessor } from '../stream-processors/update-command-processor';

import { type PassThroughCommandProps } from './command-handler';
import { StreamingCommandHandler } from './streaming-command-handler';

export class UpdateCommandHandler extends StreamingCommandHandler<ConfluenceUpdatePageCommandProperties> {
	constructor(
		props: PassThroughCommandProps,
		private updateCommandProcessor: DocumentUpdateCommandProcessor,
	) {
		super(props, 'update');
	}

	async process(payload: ConfluenceUpdatePageCommandProperties): Promise<void> {
		await this.updateCommandProcessor.streamChunk(
			payload.data.toolCalls,
			payload.isStreamComplete,
			payload.traceId,
		);
	}

	async finishAction(): Promise<DocNode | undefined> {
		await this.updateCommandProcessor.finish();
		return undefined;
	}

	abort(): void {
		this.updateCommandProcessor.abort();
	}
}
